'use client'

import { motion } from 'framer-motion'
import { Reveal } from '../Reveal'
import { Icon } from '../Icons'
import { features } from '@/lib/site-config'

export function WhyUs(): React.ReactElement {
  return (
    <section className="section-pad relative overflow-hidden bg-charcoal-950">
      {/* decorative glow */}
      <div className="absolute -top-24 right-0 h-72 w-72 rounded-full bg-gold-500/10 blur-3xl" />

      <div className="container-x relative">
        <Reveal className="mx-auto max-w-2xl text-center">
          <span className="eyebrow mb-5">لماذا نحن؟</span>
          <h2 className="font-heading text-3xl font-extrabold text-white sm:text-4xl md:text-5xl">
            لماذا <span className="gold-text">أبو صالح النييفي</span> للمقاولات؟
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {features.map((feature, i) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.6, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="group relative overflow-hidden rounded-2xl border border-white/5 bg-charcoal-900/60 p-8 text-center transition-all duration-300 hover:border-gold-500/40 hover:bg-charcoal-900"
            >
              <div className="mx-auto mb-5 inline-flex h-16 w-16 items-center justify-center rounded-2xl border border-gold-500/30 bg-gold-500/10 text-gold-300 transition-all duration-300 group-hover:scale-110 group-hover:bg-gold-gradient group-hover:text-charcoal-950">
                <Icon name={feature.icon} className="h-8 w-8" />
              </div>
              <h3 className="font-heading text-xl font-bold text-white">{feature.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-charcoal-300">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
